var map = {
	"./baac.svg": 995,
	"./bay.svg": 996,
	"./bbl.svg": 997,
	"./bnp.svg": 998,
	"./boa.svg": 999,
	"./cacib.svg": 1000,
	"./cimb.svg": 1001,
	"./citi.svg": 1002,
	"./db.svg": 1003,
	"./ghb.svg": 1004,
	"./gsb.svg": 1005,
	"./hsbc.svg": 1006,
	"./ibank.svg": 1007,
	"./icbc.svg": 1008,
	"./jpm.svg": 1009,
	"./kbank.svg": 1010,
	"./kk.svg": 1011,
	"./ktb.svg": 1012,
	"./lhb.svg": 1013,
	"./mb.svg": 1014,
	"./mega.svg": 1015,
	"./mufg.svg": 1016,
	"./rbs.svg": 1017,
	"./sc.svg": 1018,
	"./scb.svg": 1019,
	"./smbc.svg": 1020,
	"./tbank.svg": 1021,
	"./tcrb.svg": 1022,
	"./tisco.svg": 1023,
	"./tmb.svg": 1024,
	"./ttb.svg": 1025,
	"./uob.svg": 340
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 105
// module chunks = 0